import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects'
import { CREATE_GAME, DELETE_GAMES, GET_GAMES } from './constants';
import { createGameSuccess, getGames, setGames } from './actions';
import { all, create, destroyMany } from '../services/game';
import { selectGames } from './selectors';
import { waitingCount } from './gameSummary';
import { showBadge } from '../Push/badge';
import { ensureCards } from '../Cards/sagas';

function* createGameTask(action) {
  const opponentId = action.payload.get('opponentId');
  yield call(create, opponentId);
  yield put(getGames());
  yield put(createGameSuccess());
}

function* createGameWatcher() {
  yield takeLatest(CREATE_GAME, createGameTask);
}

function* deleteGamesTask(action) {
  try {
    yield call(destroyMany, action.payload.get('gameIds').toArray());
  } finally {
    // The list as it really is: without the deleted games, or with them back if the server refused.
    yield put(getGames());
  }
}

function* deleteGamesWatcher() {
  yield takeEvery(DELETE_GAMES, deleteGamesTask);
}

function* getGamesTask() {
  // Each game's picture shows its cards, which the catalog names.
  yield call(ensureCards);
  const games = yield call(all);
  yield put(setGames(games));
  // The app icon shows how many games are waiting on you; the list is where that's counted.
  yield call(showBadge, waitingCount(yield select(selectGames)));
}

function* getGamesWatcher() {
  yield takeLatest(GET_GAMES, getGamesTask);
}

export default [
  createGameWatcher,
  deleteGamesWatcher,
  getGamesWatcher,
];
